module.exports = window.XO;